import { useI18n } from '@radical/locale'
import { LAYOUT } from '../basic'

const { t } = useI18n()

const monitor: RouteRecordItem = {
  path: '/monitor',
  name: 'Monitor',
  component: LAYOUT,
  redirect: { name: 'TaskTree' },
  meta: {
    orderNo: 10,
    icon: 'fa-solid:eye',
    title: t('routes.monitor.系统观测'),
  },
  children: [
    {
      path: 'task/tree',
      name: 'TaskTree',
      component: () => import('@/pages/monitor/task.vue'),
      meta: {
        title: t('routes.monitor.任务管理'),
        icon: 'fluent:task-list-ltr-24-filled',
      },
    },
    {
      path: 'task/history',
      name: 'TaskHistory',
      component: () => import('@/pages/monitor/task-history.vue'),
      meta: {
        title: t('routes.monitor.任务历史'),
        icon: 'ix:history-list',
      },
    },
    {
      path: 'heap',
      name: 'Heap',
      component: () => import('@/pages/monitor/heap.vue'),
      meta: {
        title: t('routes.monitor.内存快照'),
        icon: 'la:memory',
      },
    },
    {
      path: 'cpu',
      name: 'Cpu',
      component: () => import('@/pages/monitor/cpu.vue'),
      meta: {
        title: t('routes.monitor.cpu分析'),
        icon: 'icon-park:cpu',
      },
    },
    {
      path: 'logs',
      name: 'Logs',
      component: () => import('@/pages/monitor/log.vue'),
      meta: {
        title: t('routes.monitor.日志列表'),
        icon: 'ix:log',
      },
    },
    {
      path: 'log-query',
      name: 'LogQuery',
      component: () => import('@/pages/monitor/log-query.vue'),
      meta: {
        title: t('routes.monitor.日志查询'),
        icon: 'mdi:magnify',
        ignoreKeepAlive: true,
        showMenu: true,
      },
    },
    {
      path: 'logs/detail/:logName',
      name: 'LogsDetail',
      component: () => import('@/pages/monitor/log-detail.vue'),
      meta: {
        title: t('routes.monitor.日志详情'),
        hideMenu: true,
      },
    },
    {
      path: 'tcpdump',
      name: 'TcpdumpCapture',
      component: () => import('@/pages/monitor/tcpdump.vue'),
      meta: {
        title: t('routes.monitor.网络抓包'),
        icon: 'mdi:network-outline',
      },
    },
    {
      path: 'track/snap/audio',
      name: 'MonitorTrackSnapAudio',
      component: () => import('@/pages/monitor/track.vue'),
      meta: {
        title: t('routes.monitor.音频轨道快照'),
        icon: 'ant-design:audio-outlined',
        hideMenu: true,
      },
    },
    {
      path: 'track/snap/video',
      name: 'MonitorTrackSnapVideo',
      component: () => import('@/pages/monitor/track.vue'),
      meta: {
        title: t('routes.monitor.视频轨道快照'),
        icon: 'ant-design:video-camera-outlined',
        hideMenu: true,
      },
    },
  ],
}

export default monitor
